import TrackChart from './TrackChart'

export default abstract class CanvasChart<T> extends TrackChart<T> {
    abstract renderCanvas(canvas: HTMLCanvasElement, data: T, scale: any): void
    abstract renderLegend(data: T): void

    render(data: T, configs, size: Dimensions): void {
        super.render(data, configs, size)
        const scale = this.buildScale(data)
        this._contents
            .selectAll('canvas.data')
            .data([null])
            .join('canvas')
            .classed('data', true)
            .style('z-index', 0)
            .style('position', 'absolute')
            .style('top', `${this.inner.top}px`)
            .style('left', `${this.inner.left}px`)
            .attr('width', this.innerWidth)
            .attr('height', this.innerHeight)
            .call(s => this.renderCanvas(s.node(), data, scale))
    }
}
